import React, { useState, useEffect } from 'react';
import Switch from 'app/scripts/components/common/inputs/customs/switch';
import useSpotConfig from '@host-panel/request/config/use-config';
import NumericInput from '../common/inputs/customs/num-input-add';

const READ_ONLY_STALENESS_KEY = 'tenant.conversation.read_only_staleness_days';
const DEFAULT_STALE_VALUE = 0;

const EnableConversationStaleness = () => {
  const [configValues, setConfig] = useSpotConfig([READ_ONLY_STALENESS_KEY], {
    [READ_ONLY_STALENESS_KEY]: -1
  });
  const [isEnabled, setIsEnabled] = useState(configValues[0] > DEFAULT_STALE_VALUE);

  const [daysUntilStaleness, setDaysUntilStaleness] = useState(DEFAULT_STALE_VALUE);

  useEffect(() => {
    setIsEnabled(configValues[0] > DEFAULT_STALE_VALUE);
    setDaysUntilStaleness(configValues[0] as number);
  }, [configValues]);

  const onChange = (isEnabled: boolean) => {
    setIsEnabled(isEnabled);

    if (!isEnabled) {
      setConfig({ key: READ_ONLY_STALENESS_KEY, value: DEFAULT_STALE_VALUE });
    }
  };

  const onSaveDaysUntilStaleness = () => {
    if (isEnabled) {
      setConfig({ key: READ_ONLY_STALENESS_KEY, value: daysUntilStaleness });
    }
  };

  const onStalenessNumberChange = (value: number) => {
    setDaysUntilStaleness(value);
  };

  return (
    <>
      <Switch
        title="Conversation Staleness"
        description="Lock commenting on an article after number of days has passed."
        value={isEnabled}
        onChange={onChange}
      />
      {isEnabled && (
        <NumericInput
          description={'Number of days until stale'}
          onClick={onSaveDaysUntilStaleness}
          onChange={onStalenessNumberChange}
          disabledAddButton={false}
          value={daysUntilStaleness}
        />
      )}
    </>
  );
};

export default EnableConversationStaleness;
